import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TenantDataService } from 'app/config/services/tenant-data.service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { GeneralAnalyticsService } from '../../../../services/general-analytics.service';
import { ExperienceWidgetContent } from '../../models/experience-widget-content.model';

@Component({
    selector: 'app-postings-carousel-dialog',
    templateUrl: './postings-carousel-dialog.component.html',
    styleUrls: ['./postings-carousel-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class PostingsCarouselDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    featuredWidget: ExperienceWidgetContent;
    index: number; //The index of the current item in the iterable.
    isFirst: boolean; //True when the item is the first item in the iterable.
    isLast: boolean; //True when the item is the last item in the iterable.

    constructor(
        public dialogRef: MatDialogRef<PostingsCarouselDialogComponent>,
        public tenantDataService: TenantDataService,
        private _locationBasedAnalyticsService: GeneralAnalyticsService,
        private _router: Router
    ) {
        super();
    }

    ngOnInit(): void {
        this.sendPostingViewEvent('posting_clicked');
    }

    nextPost() {
        this.index++;

        // checks if currently selected post is first, if that's true, we hide prev arrow
        const currentItem = this.featuredWidget.content[this.index].posting;
        const lastItem = this.featuredWidget.content[this.featuredWidget.content.length - 1].posting;

        this.isFirst = false;
        if (lastItem.id === currentItem.id) {
            this.isLast = true;
        } else {
            this.isLast = false;
        }
        this.sendPostingViewEvent('posting_clicked');
    }

    prevPost() {
        this.index--;

        // checks if currently selected post is last, if that's true, we hide next arrow
        const currentItem = this.featuredWidget.content[this.index].posting;
        const firstItem = this.featuredWidget.content[0].posting;
        this.isLast = false;
        if (firstItem.id === currentItem.id) {
            this.isFirst = true;
        } else {
            this.isFirst = false;
        }
        this.sendPostingViewEvent('posting_clicked');
    }

    openPostingUrl() {
        const posting = this.featuredWidget.content[this.index].posting;
        this.sendPostingViewEvent('posting_link_followed');

        // If the url starts with the same domain as the custom domain (whole one, not just base domain) then open internally
        if (posting.url.includes(window.location.host)) {
            this.dialogRef.close();
            window.open(`${posting.url}`, '_self');
        } else {
            const currentPostUrl = posting.url;
            window.open(currentPostUrl, '_blank');
        }
    }

    async sendPostingViewEvent(eventName: string) {
        if (this._router.url === '/grow') {
            const currentPostId = this.featuredWidget.content[this.index].posting.id;
            const postingResource = this.featuredWidget.content.find((postings) => postings.posting.id === currentPostId);
            this._locationBasedAnalyticsService.createPostingEvent(
                eventName,
                postingResource.posting.id,
                postingResource.posting.postingType.id,
                postingResource.posting.translation.title,
                postingResource.audience,
                this.featuredWidget.id,
                this.featuredWidget.name
            );
        }
    }
}
